module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-09-ef14c67bcfb8721d47b8c41576cf7f89.svg";